import { isValid } from 'utils/regexUtil';

const usernameErrorMsg =
  'Ah, that didn’t work. Your username must be at least six characters long and can only contain some special characters. Why not try something else and give it another go?';

function validateChooseUserName(values, props) {
  const errors = {};
  const { isSecondaryApplicant } = props;

  if (!isSecondaryApplicant && (!values.userName || !isValid(values.userName, 'ntbUserName'))) {
    errors.userName = usernameErrorMsg;
  } else if (
    isSecondaryApplicant &&
    (!values.secondaryUserName || !isValid(values.secondaryUserName, 'ntbUserName'))
  ) {
    errors.secondaryUserName = usernameErrorMsg;
  }
  return errors;
}

export { validateChooseUserName as validate };
